import { useEffect, useRef, useState } from 'react';

import { SavingStates } from '../enums';

const SAVING_STATE_DURATION = 2000;

const useSavingState = (isSaving: boolean) => {
  const [savingState, setSavingState] = useState<SavingStates | null>(null);
  const prevIsSaving = useRef(isSaving);
  const intervalRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    if (isSaving) {
      setSavingState(SavingStates.Saving);
    } else if (!isSaving && prevIsSaving.current) {
      setSavingState(SavingStates.Saved);
      intervalRef.current = setTimeout(() => setSavingState(null), SAVING_STATE_DURATION);
    }

    prevIsSaving.current = isSaving;

    return () => {
      intervalRef.current && clearTimeout(intervalRef.current);
    };
  }, [isSaving]);

  return { savingState };
};

export default useSavingState;
